export default __webpack_public_path__ + "static/media/WorkSans-Black.5a6f106f.woff2";